import { baseApi, API_TAGS, createEndpointBuilder } from '@/shared/api';
import type { LocationAddressesParams, LocationAddressesResponse } from '../model/types';

const locationAddressesEndpoint = createEndpointBuilder('/api/v2/locations');

export const locationAddressesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLocationAddresses: builder.query<LocationAddressesResponse, LocationAddressesParams>({
      query: ({ projectId, siteId, type, search }) => ({
        url: locationAddressesEndpoint('/addresses'),
        params: {
          projectId,
          siteId,
          type,
          ...(search && { search })
        }
      }),
      providesTags: (_result, _error, { type, search }) => [
        API_TAGS.LOCATIONS,
        { type: API_TAGS.LOCATIONS, id: `${type}-${search || 'ALL'}` }
      ]
    })
  })
});

export const { useGetLocationAddressesQuery } = locationAddressesApi;
